import React from "react";
import "./admin-panel.scss";
import { useNavigate } from "react-router-dom";

interface CardProps {
  title: string;
  description: string;
  children?: React.ReactNode;
  className?: string;
  onClick: () => void;
}

const Card: React.FC<CardProps> = ({ title, description, children, className = "", onClick }) => {
  return (
    <div className={`admin-panel--card ${className}`} onClick={onClick}>
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
      </div>
      {children && <div className="card-content">{children}</div>}
    </div>
  );
};

const cards_list = [
  { title: "Device Type Management", url: "device-type-management" },
  { title: "Customer Management", url: "customer-management" },
  { title: "Device Keys Management", url: "device-keys-management" },
  { title: "Scheduled Reports Management", url: "scheduled-reports-management/templates" },
  { title: "System Configuration", url: "system" },
  { title: "Notification Management", url: "notification-management" },
  { title: "Role Based Module Access", url: "role-module-access" },
  { title: "Health Monitoring Management", url: "health-monitoring-management" },
];

const AdminPanel = () => {
  const navigate = useNavigate();
  return (
    <div className="admin-panel--container">
      {cards_list.map((card) => (
        <Card title={card.title} description="" onClick={() => navigate(card.url)} />
      ))}
    </div>
  );
};

export default AdminPanel;
